import Load from 'components/Load';
import { createNavigationalRoute } from 'modules/app/components/NavigationalLayout';
import { RouteDescriptor, createRouteHandle } from 'routing/types';
import basePath from 'utils/basePath';

const AsyncInfoPage = Load(
  () => import(/* webpackChunkName: "info-pages" */ './components/InfoPage'),
  {},
  true,
);

export const infoPageRoute: RouteDescriptor = {
  id: 'info-pages.detail',
  path: `${basePath}/info/:uid/`,
  label: 'Info Page',
  audience: 'both',
  layout: 'navigational',
  module: 'info-pages',
};

export const infoPagesRoutes = [
  createNavigationalRoute({
    key: infoPageRoute.id,
    id: infoPageRoute.id,
    path: infoPageRoute.path,
    component: AsyncInfoPage,
    handle: createRouteHandle(infoPageRoute),
  }),
];

export const infoPagesRouteDescriptors = [infoPageRoute];

export default infoPagesRoutes;
